module.exports = __webpack_public_path__ + "img/GreekTechFireShip3_ua.81ef2a24.webp";